seedWebApp.controller('IssueModalController', ['$scope', '$uibModalInstance', '$uibModal', 'ToastService', 'HelpdeskService', 'TranslationService', 'CompanySettingService', 'item', 'DocService', '$timeout', 'PricesService', 'UserSettingService', '$rootScope',
    function ($scope, $uibModalInstance, $uibModal, ToastService, HelpdeskService, TranslationService, CompanySettingService, item, DocService, $timeout, PricesService, UserSettingService, $rootScope) {
        $scope.errors = [];
        $scope.item = item;
        $scope.stage = {};
        $scope.hasDocuments = false;

        $scope.user = CompanySettingService.getLoggedUser();        
        $scope.userID = $scope.user.UserID;
        //console.log('user', $scope.user);

        $scope.getBackStage = function (stageID) {
            //console.log('getBackStage ' + stageID);
            var activities = $scope.item.Activities;
            if (activities.length) {
                for (var i = 0; i < activities.length; i++) {
                    if (activities[i].StageID != stageID) {
                        $scope.backStageID = activities[i].StageID;
                        return;
                    }
                }                
            }
        };

        $scope.doRefresh = function ()
        {
            console.log('doRefresh');
            HelpdeskService.resetCache();
            $scope.loadDetails();
        }

        $scope.fillActivityDefaults = function (issue) {
            //Fill AccountNumber from last activity if EMPTY
            //console.log('fillFromActivities');
            if (!issue.StageFields && issue.Activities && issue.Activities.length) {
                var accountNumber = issue.Activities[0].AccountNumber;
                issue.StageFields = {
                    AccountNumber: accountNumber
                };
            }
        };

        $scope.$on('downloadPdfIssue', function (event, resolve) {
            $scope.loading = true;
            HelpdeskService.generateCreditNotePDF(item.IssueID, item.StatusID).then(
                function (response) {
                    $scope.loading = false;
                    var blob = new Blob([response.data], { type: "application/pdf" });
                    var objectUrl = URL.createObjectURL(blob);
                    var fileName = 'CreditNote_' + item.OrderID + '.pdf';
                    if (navigator.msSaveBlob) {
                        return navigator.msSaveBlob(blob, fileName);
                    }
                    var pdf = document.createElement('a');
                    pdf.href = objectUrl;
                    pdf.download = fileName;
                    pdf.click();
                    window.URL.revokeObjectURL(objectUrl);
                    $rootScope.$broadcast('downloadPdfIssueComplete');
                },
                function (err) {
                    $scope.loading = false;
                    var decoder = new TextDecoder("utf-8");
                    var errorText = decoder.decode(err.data);
                    errorText = errorText.replace(/^"|"$/g, '');
                    ToastService.createToast($scope.translation.ErrorSaving, errorText, 2000, 'error');
                }
            )
        });

        $scope.loadDetails = function () {            
            $scope.loading = true;
            HelpdeskService.getIssueDetails(item.IssueID).then(
                function (response) {
                    //console.log('getIssueDetails ', response.data);
                    $scope.item.BratID = response.data.BratID;
                    $scope.item.IsAgent = response.data.IsAgent;
                    $scope.item.Files = response.data.Files;
                    $scope.item.Activities = response.data.Activities;
                    $scope.item.Details = response.data.Details;
                    $scope.item.ApprovalUsers = response.data.ApprovalUsers;
                    $scope.item.StageFields = response.data.StageFields;
                    $scope.getBackStage($scope.item.StatusID);
                    $scope.fillActivityDefaults($scope.item);
                    $scope.getOrderDocuments(item.OrderID);
                    $scope.defineIsApprovalUser();
                    $scope.defineCreditNoteValues();

                    $scope.loading = false;
                    
                },
                function (err) {
                    $scope.loading = false;
                    //console.log('ERROR getIssueDetails', err)
                }
            );

            //console.log(item)
        };

        $scope.formatCreditNoteActivities = function (array) {
            array.forEach(function (item) {
                if (item.CreditNoteFinal !== null) {
                    item.CreditNoteFinal = item.CreditNoteFinal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
            });
        }

        $scope.defineCreditNoteValues = function () {
            var currency = $scope.item.CreditNoteCurrency ? $scope.item.CreditNoteCurrency : '';

            $scope.item.originalCreditNoteFinal = $scope.item.CreditNoteFinal;
            $scope.item.originalCreditNoteFinalConverted = $scope.item.CreditNoteFinalConverted;

            if ($scope.item.CreditNoteFinalConverted !== null) {
                $scope.item.displayCreditNoteFinalConverted = 'R$' + ' ' +
                    $scope.item.CreditNoteFinalConverted.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
            }

            if ($scope.item.CreditNoteFinal !== null) {
                $scope.item.displayCreditNoteFinal = currency + ' ' +
                    $scope.item.CreditNoteFinal.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
            }

            $scope.formatCreditNoteActivities($scope.item.Activities);
        };

        $scope.defineIsApprovalUser = function () {
            UserSettingService.getUser().then(function (response) {
                $scope.isApprovalUser = $scope.item.ApprovalUsers.some(function (user) {
                    return user.UserID == response.data.UserID
                });
            });
        }

        $scope.getOrderDocuments = function(orderID){
            DocService.getIssueFiles(orderID).then(
                function (response) {
                    $scope.Files = response.data;
                },
                function (err) {
                    $scope.Files = null;
                }
            );
        }

        if (item == null) {
            $scope.isInserting = true;
            //$scope.item = {
            //    StatusID: 'NEW',
            //    IssueType: 'INDUSTRIAL',
            //    Details: [],
            //    Files: [],
            //    Activities: [],
            //    AssignedUserIDs: [],
            //    HasCreditNote: true,
            //}
            $scope.item = {
                StatusID: 'NEW',
            };
            HelpdeskService.getNewIssue().then(
                function (response) {
                    $scope.item = response.data;
                    $scope.item.Activities = [];
                }
            );
        }
        else {
            if (!$scope.item.Files) {
                $scope.item.Files = [];                
            }            
            if (!$scope.item.AssignedUserIDs) {
                $scope.item.AssignedUserIDs = [];
            }            
            $scope.loadDetails();
        }
        //$scope.attachType = 'Imagem';
        $scope.attachType = 'Document';

        $scope.setStage = function (stageID) {
            //console.log('setStage ' + stageID);
            $scope.nextStages = [];    
            $scope.stage = $scope.stages[stageID];

            if (!$scope.stage) {
                return;
            }            
            $scope.stage.StageUserID = $scope.userID;
            $scope.stage.StageDate = new Date();
            //$scope.nextStages = $scope.stages[stageID].NextStages;
            $scope.nextStages = $scope.stages[stageID].Stages;
        }


        //console.log('Loading Stages');
        //$scope.stages = HelpdeskService.getStages();

        HelpdeskService.getStagesByID().then(
            function (response) {
                $scope.stages = response;
                $scope.setStage($scope.item.StatusID);
            }
        );
      
        
        $scope.translation = TranslationService.getActiveTranslation();        
     
        /*
        Novo indica que nenhuma ação foi tomada no ticket. Após o status Novo de um ticket ser alterado, ele nunca mais poderá ser definido como Novo.
        Aberto indica que um ticket foi atribuído a um agente e está em andamento. Ele está aguardando a ação de um agente. Você pode visualizar todos os tickets abertos usando a visualização Tickets abertos.
        Pendente indica que o agente está aguardando mais informações do solicitante. Você pode visualizar todos os tickets pendentes usando a visualização Tickets pendentes. Quando o solicitante responder, um novo comentário será adicionado e o status ticket será redefinido automaticamente para Aberto.
        Em espera indica que o agente está esperando informações ou ações de um terceiro que não é o solicitante. Ele é similar ao status Pendente, no qual você, como agente, não pode dar cabo da resolução do ticket até receber mais informações de terceiros. No entanto, Em espera é um status interno e invisível para o solicitante do ticket. Enquanto um ticket está Em espera, o solicitante vê o status como Aberto. Em espera é um status opcional e pode ser ativado por um administrador conforme descrito em Adição do status do ticket Em espera ao seu Zendesk.
        Resolvido indica que o agente enviou uma solução.
        */        
        //console.log('STAGES', $scope.stages)

        //$scope.statusTypes = HelpdeskService.getStatusTypes();
        $scope.issueTypes = HelpdeskService.getIssueTypes();

        $scope.currencies =  [
            { Key: 'R$', Value: 'R$' },
        ];

        $scope.getCurrencies = function () {
            PricesService.getCurrencies('', {}, 0, 100).then(function (response) {
                var currencies = response.data;
                currencies.forEach(function (currency) {
                    var exists = $scope.currencies.some(function (item) {
                        return item.Value === currency.CurrencySymbol || currency.CurrencySymbol == '';
                    });

                    if (!exists) 
                        $scope.currencies.push({ Key: currency.CurrencySymbol, Value: currency.CurrencySymbol });
                });
            });
        }
        $scope.getCurrencies();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $scope.loading = true;
            var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 0, 'wait');

            clearCreditNoteFinalValues();

            HelpdeskService.saveIssue($scope.item, $scope.stage).then(
                function (response) {
                    $scope.loading = false;
                    $scope.errors = response.data;
                    if ($scope.errors.length) {
                        ToastService.updateToast(toastID, $scope.translation.ErrorSaving, '', 4000, 'error');
                    }
                    else {
                        ToastService.updateToast(toastID, $scope.translation.ActionSuccessfullySaved, '', 4000, 'success');
                        $uibModalInstance.close();
                    }
                },
                function (error) {
                    $scope.loading = false;
                    //console.log('savePrice error: ');
                    //console.log(error.data);
                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, $scope.translation.ErrorSaving, errorExc, 0, 'error');
                }
            );
        };

        function clearCreditNoteFinalValues() {
            $scope.item.CreditNoteFinal = $scope.item.originalCreditNoteFinal;
            $scope.item.CreditNoteFinalConverted = $scope.item.originalCreditNoteFinalConverted;
        }

        $scope.tryBackStage = function (stageID) {
            //console.log('tryBackStage ' + stageID);
            clearCreditNoteFinalValues();
            $scope.confirmNextStage(stageID, true);
        };

        $scope.tryNextStage = function (stageID) {
            //if (!$scope.validateStage($scope.item.StatusID)) {
            //    return false;
            //}
            $scope.errors = [];

            clearCreditNoteFinalValues();

            console.log('tryNextStage ' + stageID);

            HelpdeskService.validateStateComplete($scope.item, $scope.stage, stageID)
                .then(
                    function (response) {
                        $scope.errors = response.data;
                        if (!$scope.errors.length) {
                            $scope.confirmNextStage(stageID);
                        }
                    },
                    function (err) {
                        console.log('ERROR VALIDATE', err);
                        //ToastService.updateToast(toastID, 'ERROR', '', 2000, 'error');
                    }
                );
        };

        $scope.confirmModalOpen = false;
        $scope.confirmNextStage = function (stageID, isBack) {
            var text = 'Confirm status change';
            var infoEmailSent = true;
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'SPA/helpdesk/confirmChangeModal.html?v=' + new Date().getTime(),
                controller: 'ConfirmChangeModalController',
                size: 'md',
                resolve: {
                    info: function () {
                        return {
                            Title: text,
                            FromStageID: $scope.item.StatusID,
                            ToStageID: stageID,
                            Message: 'Comments',
                            Stages: $scope.stages,
                            Approvals: $scope.item.ApprovalUsers,
                            EmailSent: infoEmailSent,
                            Issue: $scope.item,
                            IsBack: isBack
                        }
                    },
                    //isDanger: false,
                }
            });

            $scope.confirmModalOpen = true;
            modalInstance.result.then(                
                function (info) {
                    //$uibModalInstance.close($scope.scopeItem);
                    $scope.confirmModalOpen = false;
                    //console.log('TROCAR STATUS ', stageID, info);
                    $scope.saveNextStage(stageID, isBack, info);
                }, function () {
                    //console.log('ConfirModalOpen CANCELED');
                    $scope.confirmModalOpen = false;
                }
            );

        };

        $scope.saveNextStage = function (stageID, goBack, info) {
            var toastID = ToastService.createToast('Updating state', '', 4000, 'wait');
            HelpdeskService.updateState($scope.item, stageID, $scope.stage, goBack, info.EmailSent)
                .then(
                    function (response) {
                        $scope.errors = response.data;
                        if ($scope.errors.length) {
                            ToastService.updateToast(toastID, 'Erros ao salvar', '', 2000, 'error');
                        }
                        else {
                            ToastService.updateToast(toastID, 'Updated', '', 2000, 'success');
                            $uibModalInstance.close();
                        }
                    },
                    function (err) {
                        console.log('ERROR', err);
                        ToastService.updateToast(toastID, 'ERROR', '', 2000, 'error');
                    }
            );
        };

        $scope.validateStage = function (stageID) {
            //console.log('validateStage ' + stageID);
            //return true;
            HelpdeskService.validateStateComplete($scope.item, stageID)
                .then(
                    function (response) {
                        //ToastService.updateToast(toastID, 'Updated', '', 2000, 'success');
                        //$uibModalInstance.close();
                    },
                    function (err) {
                        console.log('ERROR', err);
                        //ToastService.updateToast(toastID, 'ERROR', '', 2000, 'error');
                    }
                );
        };

        $scope.orderSearch = function (query) {
            //Verificar se tem filtro de CLIENTE
            var contactID = $scope.item.ContactID;
            if (!contactID) {
                contactID = ' ';
            }
            return HelpdeskService.getOrdersQuery(query, contactID)
                .then(function (response) {
                    return response.data.map(function (item) {
                        return item;
                    });
                })
                .catch(function (err) {
                    console.error(err);
                });
        };

        $scope.contactSearch = function (query) {
            return HelpdeskService.getContactsQuery(query)
                .then(function (response) {
                    return response.data.map(function (item) {
                        return item;
                    });
                })
                .catch(function (err) {
                    console.error(err);
                });
        };

        $scope.selectOrder = function (item) {
            console.log('after selectOrder ', item);
            if (item && item.ContactID) {
                $scope.item.ContactID = item.ContactID;
            }
            $scope.getOrderDocuments(item.Key);
        };

        $scope.onSelectEvents = function (item) {
            
            $scope.issueEvents = [{ EVENTS: 'EVENTS' }];
            HelpdeskService.getIssueEvents(item.IssueID).then(
                function (response) {
                    item.Events = response.data;
                }
            )
            
        };

        $scope.stageHasValues = function (stageID) {

        };

        //--------------------------------------------------
        //  Se houver Fase que tem custo, deve ser OBRIGATORIA
        //--------------------------------------------------
        $scope.isStageEnabled = function (stageID) {
            if ($scope.isInserting) {
                return false;
            }

            var stage = $scope.stages[stageID];

            if (!stage.IsEnabled) {
                return false;
            }

            var isEnabled ;
            if (stage.HasCreditNote) {
                isEnabled = $scope.item.HasCreditNote;
            }
            else {
                isEnabled = true;
            }

            if (isEnabled) {
                isEnabled = !$scope.isStageForbidden(stageID);
            }

            return isEnabled;
        }

        //Se tiver fase que tem custo e o stage for de APROVAÇÃO
        $scope.isStageForbidden = function (stageID) {
            //console.log('isStageForbidden ' + stageID);

            var stage = $scope.stages[stageID];
            if ($scope.item.HasCreditNote) {
                if (stage.IsApproved) {
                    //return $scope.item.HasCreditNote;
                    var hasStageCost = $scope.hasStageWithCosts(stageID);
                    if (hasStageCost) {
                        return true;
                    }
                }
            }           
            return false;
        }

        $scope.hasStageWithCosts = function (curStageID) {
            if ($scope.nextStages && $scope.nextStages.length > 0) {                
                for (var i in $scope.nextStages) {
                    var stageID = $scope.nextStages[i];
                    var stage = $scope.stages[stageID];
                    if (stage.HasCreditNote) {
                        return true;
                    }
                }                
            }
            return false;
        };

        //$scope.isStageRequired = function (stageID) {
        //    var stage = $scope.stages[stageID];
        //    if (!stage.IsEnabled) {
        //        return false;
        //    }
        //    if (!stage.MinCreditApproval) {
        //        if (stage.MaxCreditApproval) {
        //            return $scope.item.CreditNoteClaim <= stage.MaxCreditApproval;
        //        }
        //        else {
        //            return true;
        //        }
        //    }
        //    if ($scope.item.CreditNoteClaim >= stage.MinCreditApproval) {                
        //        if ($scope.item.CreditNoteClaim <= stage.MaxCreditApproval) {
        //            return true;
        //        }
        //    }
        //    return false;
        //};

        $scope.getStageTitle = function (stageID, isBack) {           
            if (!$scope.stages) {
                return '';
            }
            var stage = $scope.stages[stageID];
            if (!stage) {
                return '';
            }
            var msg = '';
            if (isBack) {
                msg += 'VOLTAR para a fase: ';
            }
            else {
                msg += 'Vai para a fase: ';
            }
            msg += stage.StageName;
            msg += '\n';
            msg += stageID;
            msg += '\n';
            /*
            if (stage.MinCreditApproval || stage.MaxCreditApproval) {

                msg += 'Valores: ' + stage.MinCreditApproval + ' a ' + stage.MaxCreditApproval;
            }
            */
            return msg;
        };

        $scope.canModifyClaim = function () {
            if ($scope.item.ApprovalUsers) {
                if ($scope.item.ApprovalUsers.length) {
                    return false;
                }
            }
            if (!$scope.item.HasCreditNote) {
                return false;
            }
            return true;
        };

        //$scope.isAllApproved = function () {
        //    var allApproved = true;
        //    if ($scope.item.ApprovalUsers && $scope.item.ApprovalUsers.length) {
        //        for (var i in $scope.item.ApprovalUsers) {
        //            var ap = $scope.item.ApprovalUsers[i];
        //            if (!ap.IsApproved)
        //            {
        //                allApproved = false;
        //            }                    
        //        }
        //    }
        //    return allApproved;
        //};

        $scope.isAllApproved = function () {
            if (!$scope.item.ApprovalUsers || $scope.item.ApprovalUsers.length === 0) {
                return false; // No approval users, hence not all approved
            }
            return $scope.item.ApprovalUsers.every(function (user) {
                return user.IsApproved;
            });
        };


        $scope.$on('approvalStatusChanged', function (event, approval) {
            //console.log('issueModal.approvalStatusChanged', approval);
            if ($scope.isAllApproved()) {

                //Verificar se janela já esta aberta

                if ($scope.confirmModalOpen) {
                    console.log('MODAL CONFIRMAR JA ESTA ABERTO!!');
                    return;
                }
                var nextStage = $scope.getNextStage();
                if (nextStage)
                { 
                    $scope.tryNextStage(nextStage);
                }
            }
        });        

        $scope.getNextStage = function () {          
            if ($scope.nextStages && $scope.nextStages.length > 0) {
                for (var i in $scope.nextStages) {
                    var nextStage = $scope.nextStages[i];
                    if ($scope.isStageEnabled(nextStage)) {
                        return nextStage
                    }                    
                }
            }
            return null;
        };
    }
]);
